import { IOnInit } from "angular";
import { GridConfiguration } from "../../../../records/views/recordGridView";

export class RoleDetailUserComponentController implements IOnInit {
  static $inject = [];

  // bindings
  gridConfiguration!: GridConfiguration;
  //end bindings

  $onInit(): void {}
}
